import config from "../config";

const baseURL = config.REACT_APP_API_URL;

const getToken = () => localStorage.getItem("access_token");

const parseError = async (res) => {
  try {
    const data = await res.json();
    return data.detail || data.message || "Unknown error";
  } catch {
    return `Error ${res.status}`;
  }
};

export const api = {
  get: async (path) => {
    const res = await fetch(`${baseURL}${path}`, {
      headers: { Authorization: getToken() }
    });
    if (!res.ok) throw new Error(await parseError(res));
    return res.json();
  },

  post: async (path, body) => {
    const res = await fetch(`${baseURL}${path}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken()
      },
      body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await parseError(res));
    return res.json();
  },

  put: async (path, body) => {
    const res = await fetch(`${baseURL}${path}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken()
      },
      body: JSON.stringify(body)
    });
    if (!res.ok) throw new Error(await parseError(res));
    return res.json();
  },

  delete: async (path) => {
    const res = await fetch(`${baseURL}${path}`, {
      method: "DELETE",
      headers: { Authorization: getToken() }
    });
    if (!res.ok) throw new Error(await parseError(res));
    return res.json();
  },
};
